import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './initialState';
import {
  getNotMeasuredSettingsAsync,
  putNotMeasuredSettingsAsync,
  getNotMeasuredDeviceTypeMapAsync,
} from './asyncActions';

export const notMeasuredSettingsSlice = createSlice({
  name: 'notMeasuredSettings',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getNotMeasuredSettingsAsync.pending, (state) => {
        state.settings.status = 'loading';
      })
      .addCase(getNotMeasuredSettingsAsync.fulfilled, (state, action) => {
        state.settings.status = 'idle';
        state.settings.data = action.payload?.item ?? null;
      })
      .addCase(getNotMeasuredSettingsAsync.rejected, (state) => {
        state.settings.status = 'failed';
      })
      .addCase(putNotMeasuredSettingsAsync.pending, (state) => {
        state.saveStatus = 'loading';
      })
      .addCase(putNotMeasuredSettingsAsync.fulfilled, (state) => {
        state.saveStatus = 'idle';
      })
      .addCase(putNotMeasuredSettingsAsync.rejected, (state) => {
        state.saveStatus = 'failed';
      })
      .addCase(getNotMeasuredDeviceTypeMapAsync.pending, (state) => {
        state.deviceMap.status = 'loading';
      })
      .addCase(getNotMeasuredDeviceTypeMapAsync.fulfilled, (state, action) => {
        state.deviceMap.status = 'idle';
        state.deviceMap.data = action.payload?.items ?? [];
      })
      .addCase(getNotMeasuredDeviceTypeMapAsync.rejected, (state) => {
        state.deviceMap.status = 'failed';
      });
  },
});

export default notMeasuredSettingsSlice.reducer;
